import React, { useState } from 'react';
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const QUICK_LINKS = [
    { label: 'Home',     id: 'home' },
    { label: 'About Us', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Why Us',   id: 'whyus' },
    { label: 'Contact',  id: 'contact' },
];

const SERVICE_LINKS = [
    'Business Strategy',
    'Technology Solutions',
    'Financial Advisory',
    'Project Management',
    'Training & Capacity',
    'Government Advisory',
];

const SOCIALS = [
    { icon: <FaLinkedin />,  href: '#' },
    { icon: <FaTwitter />,   href: '#' },
    { icon: <FaFacebook />,  href: '#' },
    { icon: <FaInstagram />, href: '#' },
];

const Footer = () => {
    const [email, setEmail] = useState('');
    const [subbed, setSubbed] = useState(false);

    const handleSub = (e) => {
        e.preventDefault();
        if (email) { setSubbed(true); setEmail(''); }
    };

    return (
        <footer className="footer">
            <div className="footer-grid">
                {/* Brand */}
                <div>
                    <div className="footer-brand-name">
                        <span className="brand-connect">CONNECT</span>
                        <span className="brand-rest"> ALL (SL)</span>
                    </div>
                    <p className="footer-brand-desc">
                        Sierra Leone's leading business consulting firm — connecting ambition
                        to achievement since 2013.
                    </p>
                    <div className="social-icons">
                        {SOCIALS.map((s, i) => (
                            <a key={i} href={s.href} className="social-icon" target="_blank" rel="noreferrer">
                                {s.icon}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Quick links */}
                <div>
                    <p className="footer-title">Quick Links</p>
                    <ul className="footer-links">
                        {QUICK_LINKS.map(l => (
                            <li key={l.id} className="footer-link" onClick={() => scrollTo(l.id)}>
                                {l.label}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Services */}
                <div>
                    <p className="footer-title">Services</p>
                    <ul className="footer-links">
                        {SERVICE_LINKS.map(s => (
                            <li key={s} className="footer-link" onClick={() => scrollTo('services')}>
                                {s}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Newsletter */}
                <div>
                    <p className="footer-title">Stay Updated</p>
                    <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', marginBottom: '1.25rem', lineHeight: 1.6 }}>
                        Subscribe for our latest insights, market reports, and business tips.
                    </p>
                    {subbed ? (
                        <p style={{ color: 'var(--green)', fontSize: '0.9rem', fontWeight: 600 }}>
                            ✓ Thank you for subscribing!
                        </p>
                    ) : (
                        <form className="footer-newsletter" onSubmit={handleSub}>
                            <input
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="footer-newsletter-btn">
                                Subscribe
                            </button>
                        </form>
                    )}
                </div>
            </div>

            <div className="footer-bottom">
                <p className="footer-copy">© {new Date().getFullYear()} CONNECT ALL (SL) LTD. All Rights Reserved.</p>
                <div className="footer-bottom-links">
                    <span className="footer-bottom-link">Privacy Policy</span>
                    <span className="footer-bottom-link">Terms of Service</span>
                    <span className="footer-bottom-link">Cookie Policy</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;